<template>
	<div :id="itemMdata.allId" class="resizable" :class="['hove_con',itemMdata.emitStr,'m_'+itemMdata.tName]" :style="[parentStyle,{width:itemMdata.fullScreen?'100%':itemMdata.parentStyle.width+'px',height:itemMdata.parentStyle.height+'px'}]">
		<div :itemMdata="itemMdata" :is="itemMdata.tName"></div>
	</div>
</template>
<script>
	let ov = {};
	let mName = ['mFont', 'mImage', 'mButton', 'graphic', 'mNewDes', 'columnPicture', 'mCaseDes', 'mPhotoDes', 'multiCarousel', 'circleRrea', 'articleScrap', 'productNav', 'newlyShop', 'productShow', 'productDes', 'productSearch', 'photoMoreCard', 'areaFile', 'areaMap', 'areaIndexFavorite', 'areaLocation', 'areaMap', 'sidebar', 'moduleAreaNav', 'footerNav', 'memberLogin', 'msgSubmit', 'siteForm', 'serviceOnline', 'siteQrCode', 'videoNav', 'zhaopin', 'zhaopinDetail', 'areaFileNav', 'mltilingual', 'areaCode', 'sitemap', 'singlePage', 'areaDate', 'areaFlv', 'friendLink', 'searchResults'];

	for(let m = 0; mName.length > m; m++) {
		ov[mName[m]] = () =>
			import('./m/' + mName[m] + '.vue');
	}

	export default {
		name: 'mConet',
		props: ['itemMdata', "itemInner"],
		components: ov,
		created() {
			let ts = this;
			ts.parentStyle.top = ts.itemMdata.parentStyle.top + "px";
			ts.parentStyle.left = ts.itemMdata.parentStyle.left + "px";
			ts.parentStyle.position = "absolute";
			ts.parentStyle.width = ts.itemMdata.parentStyle.width + "px";
			ts.parentStyle.height = ts.itemMdata.parentStyle.height + "px";
			ts.parentStyle.zIndex = ts.itemMdata.parentStyle.zIndex;
		},
		methods: {
			manageMfont() {
				//console.log(item);				
				//this.$refs.child.editorFun();
			}
		},
		mounted() {
			let ts = this;
			if(ts.itemMdata.emitStr) {
				setTimeout(function(){
					hoverAction.initScroll(ts.itemMdata.allId, ts.itemMdata.emitStr);
				},400);
				
			}
		},
		data() {
			return {
				title: "模块容器",
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					type: this.$route.query.type,
					lang: this.$route.query.lang,
					domain_url: this.$route.query.domain_url,
					mobile_version_id: this.$route.query.mobile_version_id,
					pc_version_id: this.$route.query.pc_version_id
				},
				parentStyle: {}
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.pc_con .hove {}
</style>


// WEBPACK FOOTER //
// src/components/t2/prev/mConet.vue